/**
 * Module for having different languages in the editor
 *
 * Usage:
 * var _ = require('some/path/to/language');
 *
 * document.write(_("Text to be translated"));
 * document.write(_("There are %s images in this folder", 10))
 *
 */
import langNo from './lang.no.js'
import langNl from './lang.nl.js'
import langEn from './lang.en.js'
import langDe from './lang.de.js'
import langFr from './lang.fr.js'
import langSe from './lang.se.js'
import langDk from './lang.dk.js'
import langEs from './lang.es.js'
import langIt from './lang.it.js'
import langPt from './lang.pt.js'

var translations = {};
translations['nl-NL'] = langNl;
translations['nl-BE'] = langNl;
translations['nb-NO'] = langNo;
translations['en-GB'] = langEn;
translations['en-IE'] = langEn;
translations['de-DE'] = langDe;
translations['de-AT'] = langDe;
translations['fr-FR'] = langFr;
translations['sv-SE'] = langSe;
translations['es-ES'] = langEs;
translations['it-IT'] = langIt;
translations['pt-PT'] = langPt;
translations['da-DK'] = langDk;


/**
 * The translate function. Can take any number of parameters, where
 * the first is the text to translate, and the others is parameters to 
 * replace in the text where the text has these: %s
 */
function Language () {
	var text = arguments[0];

	if (translations[sessionStorage.getItem("language")] === undefined) {
		throw Error("There is no language file for the language: " + sessionStorage.getItem("language"));
	}

	var translatedText = translations[sessionStorage.getItem("language")][text];
	if (translatedText == null || translatedText === "") {
		translatedText = text;
	}

	for (var i = 1; i < arguments.length; i++) {
		translatedText = translatedText.replace("%s", arguments[i]);		
	}
	return translatedText;
}


export default Language; 
